import { initModals } from "flowbite";

export const defaultParams = {
    current_url: null,
    force_display: false,
    lang: null,
    subscription_url: null,
    callback: null,
}

/**
 * Récupère la modal en ajax
 *
 * @param params   Paramètres à envoyer en POST
 * @returns {Promise<null|*>}
 * @version 0.0.1 - 04/03/2025 by LM -
 */
const getModalPromoCode = async (params) => {
    try {
        const response = await fetch('/pcsoft-promo-code/ajax-modal', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        })

        // Si la réponse n'est valide
        if(!response.ok) {
            return null;
        }

        const data = await response.json();

        if(!data || !data.success || !data.content) {
            return null;
        }

        return data.content;

    }catch (error) {
        return null;
    }
}

/**
 * Initialise le composant pour afficher la modal du code promo
 *
 * @param params    Paramètres à envoyer pour récupérer la modal (current_url, force_display, lang, subscription_url)
 * @param target    Element cible dans lequel injecter la modal
 * @version 0.0.1 - 04/03/2025 by LM -
 */
export async function initModalPromoCode (params, target = 'body') {

    let mergedParams = {...defaultParams, ...params}

    // L'url n'est pas passé dans les paramètres, on l'affecte dynamiquement
    if(!mergedParams.current_url) {
        mergedParams.current_url = window.location.href
    }

    // Récupération de l'élément dans lequel on va injecter la modale
    const targetEl = document.querySelector(target)
    if(!targetEl) {
        console.error('PCSOFT Promo Code : Target element not found')
        return
    }

    // Récupération de la modale + injection
    const modalHtml = await getModalPromoCode(mergedParams)
    if(modalHtml) {
        targetEl.insertAdjacentHTML('beforeend', modalHtml)

        // Possibilité de copier le code directement en cliquant sur le bouton
        document.querySelector('[data-copy-promo-code]').addEventListener('click', function () {
            const promoCode = document.querySelector('[data-copy-promo-code]');
            navigator.clipboard.writeText(promoCode.dataset.copyPromoCode);
        });

        // Appel de la callback si elle existe
        if(mergedParams.callback && typeof mergedParams.callback === 'function') {
            mergedParams.callback()
        }

        // Initialise les modales de Flowbite
        initModals();
    }
}
